const formatStatus = (status: string | undefined): string => {
  if (!status) return '-'

  const statusMap: Record<string, string> = {
    pending: 'Menunggu',
    menunggu: 'Menunggu',
    processing: 'Proses',
    proses: 'Proses',
    approved: 'Disetujui',
    disetujui: 'Disetujui',
    rejected: 'Ditolak',
    ditolak: 'Ditolak',
    paid_off: 'Lunas',
    lunas: 'Lunas',
    active: 'Aktif',
    inactive: 'Nonaktif',
  }

  return statusMap[status.toLowerCase()] || status
}

export default {
  status: formatStatus,
}
